"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconQuestionOutline = function IconQuestionOutline(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconQuestionOutline', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("g", {
    fill: "none"
  }, _react.default.createElement("path", {
    fill: "currentColor",
    d: "M3 1.5A1.5 1.5 0 001.5 3v10A1.5 1.5 0 003 14.5h10a1.5 1.5 0 001.5-1.5V3A1.5 1.5 0 0013 1.5H3zM3 0h10a3 3 0 013 3v10a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3z"
  }), _react.default.createElement("path", {
    d: "M8.126 3.96c.285.03.568.076.847.138.853.24 1.36.914 1.424 1.81a1.64 1.64 0 01-.674 1.506c-.227.174-.465.333-.694.504a1.112 1.112 0 00-.509.998.633.633 0 01-.46.633.712.712 0 01-.83-.245.66.66 0 01-.094-.328 2.191 2.191 0 01.912-1.847c.257-.194.5-.406.725-.634a.789.789 0 00.187-.445c.037-.448-.254-.737-.723-.767-.567-.036-1.043.11-1.376.605a.672.672 0 01-.696.317c-.48-.08-.687-.466-.49-.91.206-.435.56-.782 1-.983a3.51 3.51 0 011.451-.352zm.479 7.11c.003.509-.285.811-.789.811s-.84-.291-.842-.717c0-.591.268-.886.8-.902.434-.012.885.25.83.808z",
    fill: "#currentColor"
  })));
};

var _default = IconQuestionOutline;
exports.default = _default;